import React from 'react';

/**
 * TickerBar — horizontal auto-scrolling date ticker.
 *
 * Renders the same item twice so a CSS animation translating the track
 * by -50% produces a seamless loop. The template supplies styling
 * (animation, colors, separator) via `classes`.
 *
 * Props:
 *   text       — string shown in each ticker item (e.g. "02.05.2026")
 *   separator  — separator between items (default ' / ')
 *   repeat     — how many items per half-track (default 10)
 *   classes    — { bar, track, item, sep } — host template supplies styling
 */
export default function TickerBar({
  text,
  separator = ' / ',
  repeat   = 10,
  classes  = {},
}) {
  const items = (key) => Array.from({ length: repeat }, (_, i) => (
    <span key={`${key}-${i}`} className={classes.item || 'ticker-item'}>
      {text}
      <span className={classes.sep || 'ticker-sep'}>{separator}</span>
    </span>
  ));
  return (
    <div className={classes.bar || 'ticker-bar'}>
      <div className={classes.track || 'ticker-track'}>
        {items('a')}
        {items('b')}
      </div>
    </div>
  );
}
